module.exports = __webpack_public_path__ + "static/media/dqframework.cfd04f2e.png";